/* eslint-disable */
// THIS FILE WAS GENERATED
// ALL CHANGES WILL BE OVERWRITTEN

// INFRASTRUCTURE START
export type StandardError = globalThis.Error;
export type Error500s =
  | 501
  | 502
  | 503
  | 504
  | 505
  | 506
  | 507
  | 508
  | 510
  | 511;
export type ErrorStatuses = 0 | Error500s;
export type ErrorResponse = FetchResponse<unknown, ErrorStatuses>;

export type FetchResponseOfError = {
  data: null;
  error: StandardError;
  status: ErrorStatuses;
  args: FetchArgs;
};

export type FetchResponseOfSuccess<TData, TStatus extends number = 0> = {
  data: TData;
  error: null;
  status: TStatus;
  args: FetchArgs;
  responseHeaders: Headers;
};

export type FetchResponse<
  TData,
  TStatus extends number = 0,
> = TStatus extends ErrorStatuses
  ? FetchResponseOfError
  : FetchResponseOfSuccess<TData, TStatus>;

export type TerminateRequest = null;
export type TerminateResponse = null;

export type Configuration = {
  apiUrl: string | (() => string);
  jwtKey: string | undefined | (() => string | null | undefined);
  requestMiddlewares?: Array<{
    name: string;
    fn: (request: FetchArgs) => FetchArgs | TerminateRequest;
  }>;
  responseMiddlewares?: Array<{
    name: string;
    fn: <TData, TStatus extends number>(
      response: FetchResponse<TData, TStatus>,
    ) => FetchResponse<TData, TStatus> | TerminateResponse;
  }>;
};

let CONFIG: Configuration = {
  apiUrl: () => "",
  jwtKey: undefined,
  requestMiddlewares: [],
  responseMiddlewares: [],
};

export function setupClient(configuration: Configuration) {
  CONFIG = {
    ...CONFIG,
    ...configuration,
    requestMiddlewares: [
      ...(CONFIG.requestMiddlewares || []),
      ...(configuration.requestMiddlewares || []),
    ],
    responseMiddlewares: [
      ...(CONFIG.responseMiddlewares || []),
      ...(configuration.responseMiddlewares || []),
    ],
  };
}

export function getApiUrl() {
  if (typeof CONFIG.apiUrl === "function") {
    return CONFIG.apiUrl();
  }
  return CONFIG.apiUrl;
}

export type Termination = {
  termination: {
    name: string;
  };
};

export function processRequestWithMiddlewares(
  request: FetchArgs,
): FetchArgs | Termination {
  for (const middleware of CONFIG.requestMiddlewares || []) {
    try {
      const middlewareResponse = middleware.fn(request);
      if (middlewareResponse === null) {
        return { termination: { name: middleware.name } };
      }
      return middlewareResponse;
    } catch (e) {
      console.error("Request middleware error", e);
    }
  }
  return request;
}

export function processResponseWithMiddlewares<TData, TStatus extends number>(
  response: FetchResponse<TData, TStatus>,
): FetchResponse<TData, TStatus | 0> {
  for (const middleware of CONFIG.responseMiddlewares || []) {
    try {
      const middlewareResponse = middleware.fn(response);
      if (middlewareResponse === null) {
        return {
          status: 0,
          args: response.args,
          data: null,
          error: new Error(
            `Response terminated by middleware: ${middleware.name}`,
          ),
        } satisfies FetchResponseOfError;
      }
      response = middlewareResponse;
    } catch (e) {
      console.error("Response middleware error", e);
    }
  }
  return response;
}

export type FetchArgsOptions = Omit<
  RequestInit,
  "method" | "redirect" | "body"
>;

export type FetchArgs = {
  url: string;
  options: RequestInit;
};

export type UriComponent = string | number | boolean;
export type ParamsObject = {
  [key: string]: UriComponent | UriComponent[] | undefined | null;
};

export async function fetchJson<TData>(
  args: FetchArgs,
): Promise<FetchResponse<TData, number> | FetchResponseOfError> {
  const errorResponse = (
    error: StandardError,
    status: number,
    args: FetchArgs,
  ) => {
    const errorResponse = {
      status: status as ErrorStatuses,
      args,
      data: null,
      error,
    } satisfies FetchResponseOfError;

    return processResponseWithMiddlewares(errorResponse);
  };

  const errorStatus = (args: FetchArgs) => {
    const errorResponse = {
      status: 0,
      args,
      data: null,
      error: new Error("Network error"),
    } satisfies FetchResponseOfError;

    return processResponseWithMiddlewares(errorResponse);
  };

  try {
    const fetchRequest = processRequestWithMiddlewares(args);

    if ("termination" in fetchRequest) {
      const terminationResponse = {
        status: 0,
        args,
        data: null,
        error: new Error(
          `Request terminated by middleware: ${fetchRequest.termination.name}`,
        ),
      } satisfies FetchResponseOfError;

      return processResponseWithMiddlewares(terminationResponse);
    }

    const fetchResponse: Response = await fetch(
      fetchRequest.url,
      fetchRequest.options,
    );
    const status = fetchResponse.status;
    try {
      const json = await fetchResponse.json();
      const response = {
        data: json,
        status: fetchResponse.status,
        args,
        error: null,
        responseHeaders: fetchResponse.headers,
      };
      return processResponseWithMiddlewares(response);
    } catch (error) {
      return errorResponse(error as StandardError, status, args);
    }
  } catch {
    return errorStatus(args);
  }
}

export function getJwtKey(): string | null | undefined {
  if (typeof CONFIG.jwtKey === "function") {
    return CONFIG.jwtKey();
  }

  if (typeof CONFIG.jwtKey === "string") {
    return localStorage.getItem(CONFIG.jwtKey);
  }

  return undefined;
}

function getApiRequestData<Type extends any>(
  requestContract: Type | undefined,
  isFormData: boolean = false,
): FormData | Type | {} {
  if (!isFormData) {
    return requestContract !== undefined ? requestContract : {};
  }

  //multipart/form-data
  const formData = new FormData();

  if (requestContract) {
    Object.keys(requestContract).forEach((key) => {
      const value = requestContract[key as keyof Type];
      const isKeyArrayAndValueIterable =
        key.endsWith("[]") &&
        typeof (value as any)[Symbol.iterator] === "function";
      const values = isKeyArrayAndValueIterable
        ? Array.from(value as Iterable<any>)
        : [value];
      for (const val of values) {
        if (val === undefined) {
          continue;
        }
        if (val === null) {
          formData.append(key, "");
        } else if (val instanceof File) {
          formData.append(key, val);
        } else if (typeof val === "object" && val !== null) {
          formData.append(key, JSON.stringify(val));
        } else {
          formData.append(key, val);
        }
      }
    });
  }

  return formData;
}

function updateHeaders(headers: HeadersInit) {
  const token = getJwtKey();
  if (headers instanceof Headers) {
    if (!headers.has("Content-Type")) {
      headers.append("Content-Type", "application/json");
    }
    if (!headers.has("Authorization") && !!token) {
      headers.append("Authorization", token);
    }
    return;
  }

  if (Array.isArray(headers)) {
    if (!headers.find(([key]) => key === "Content-Type")) {
      headers.push(["Content-Type", "application/json"]);
    }
    if (!headers.find(([key]) => key === "Authorization") && !!token) {
      headers.push(["Authorization", token]);
    }
    return;
  }

  if (!headers["Content-Type"]) {
    headers["Content-Type"] = "application/json";
  }
  if (!headers.Authorization && !!token) {
    headers.Authorization = token;
  }
}

function removeContentTypeHeader(headers: HeadersInit) {
  if (headers instanceof Headers) {
    headers.delete("Content-Type");
    return;
  }

  if (Array.isArray(headers)) {
    return headers.filter(([key]) => key !== "Content-Type");
  }

  delete headers["Content-Type"];
}

export function createRequest<TRequest>(
  method: string,
  request: TRequest | undefined,
  options: FetchArgsOptions | undefined,
  url: string,
  paramsObject: ParamsObject = {},
) {
  const fetchOptions = options ?? {};

  if (!fetchOptions.headers) {
    fetchOptions.headers = new Headers();
  }

  updateHeaders(fetchOptions.headers);
  if (request instanceof FormData) {
    removeContentTypeHeader(fetchOptions.headers);
  }

  const body = request instanceof FormData ? request : JSON.stringify(request);
  const maybeQueryString = getQueryParamsString(paramsObject);

  const requestOptions: RequestInit = {
    ...fetchOptions,
    method,
    body,
    redirect: "follow",
  };

  return {
    options: requestOptions,
    url: `${url}${maybeQueryString}`,
  } as FetchArgs;
}

export function getQueryParamsString(paramsObject: ParamsObject = {}) {
  const queryString = Object.entries(paramsObject)
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map((val) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
          .join("&");
      }
      // Handling non-array parameters
      return value !== undefined && value !== null
        ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        : "";
    })
    .filter((part) => part !== "")
    .join("&");

  return queryString.length > 0 ? `?${queryString}` : "";
}

export function apiPost<
  TResponse extends FetchResponse<unknown, number>,
  TRequest,
>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {},
) {
  return fetchJson<TResponse>(
    createRequest("POST", request, options, url, paramsObject),
  );
}

export function apiGet<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {},
) {
  return fetchJson<TResponse>(
    createRequest("GET", undefined, options, url, paramsObject),
  );
}

export function apiPut<
  TResponse extends FetchResponse<unknown, number>,
  TRequest,
>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {},
) {
  return fetchJson<TResponse>(
    createRequest("PUT", request, options, url, paramsObject),
  );
}

export function apiDelete<TResponse extends FetchResponse<unknown, number>>(
  url: string,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {},
) {
  return fetchJson<TResponse>(
    createRequest("DELETE", undefined, options, url, paramsObject),
  );
}

export function apiPatch<
  TResponse extends FetchResponse<unknown, number>,
  TRequest,
>(
  url: string,
  request: TRequest,
  options: FetchArgsOptions | undefined,
  paramsObject: ParamsObject = {},
) {
  return fetchJson<TResponse>(
    createRequest("PATCH", request, options, url, paramsObject),
  );
}
// INFRASTRUCTURE END

export type ApiProblemDetails = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export type ErrorDetail = {
  code: ErrorCode;
  message?: string | null;
};

export enum ErrorCode {
  Unspecified = "Unspecified",
  OutOfRange = "OutOfRange",
  NotFound = "NotFound",
  Invalid = "Invalid",
  Forbidden = "Forbidden",
  TooManyRequests = "TooManyRequests",
  Conflict = "Conflict",
  NullOrEmpty = "NullOrEmpty",
  Unauthorized = "Unauthorized",
  ExternalProviderNotAvailable = "ExternalProviderNotAvailable",
}

export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export type EntityListOfUserListItemDto = {
  offset: number;
  limit: number;
  totalCount: number;
  items: UserListItemDto[];
};

export type UserListItemDto = {
  userID: number;
  email: string;
  firstName: string;
  lastName: string;
  dateCreated: string;
  coins: number;
  xp: number;
  picture?: string | null;
  position?: string | null;
  activeRequests: number;
  activeQuests: number;
  pendingApprovals: number;
};

export type UserDetailDto = {
  userID: number;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  xp: number;
  coins: number;
  role: UserRole;
  label: UserLabel;
  picture?: string | null;
};

export enum UserRole {
  User = "User",
  ProjectManager = "ProjectManager",
  GameMaster = "GameMaster",
}

export enum UserLabel {
  GameMaster = "GameMaster",
  Noob = "Noob",
  Adventurer = "Adventurer",
  Hero = "Hero",
  Mastermind = "Mastermind",
  Legend = "Legend",
  Champion = "Champion",
}

export type RewardData = {
  rewardID: number;
  name: string;
  description?: string | null;
  state: RewardState;
  cost: number;
  totalQuantity?: number | null;
  claimedQuantity: number;
  dateStart?: string | null;
  dateExpiration?: string | null;
};

export enum RewardState {
  Requested = "Requested",
  Upcoming = "Upcoming",
  Active = "Active",
  Expired = "Expired",
  Canceled = "Canceled",
  Archived = "Archived",
}

export type RewardOverview = {
  rewards: EntityListOfRewardDetail;
};

export type EntityListOfRewardDetail = {
  offset: number;
  limit: number;
  totalCount: number;
  items: RewardDetail[];
};

export type RewardDetail = {
  rewardID: number;
  name: string;
  description?: string | null;
  state: RewardState;
  cost: number;
  totalQuantity?: number | null;
  claimedQuantity: number;
  dateStart?: string | null;
  dateExpiration?: string | null;
};

export type RewardListRequest = {
  offset: number;
  limit: number;
  name?: string | null;
};

export type CreateOrUpdateRewardCommand = {
  rewardID?: number | null;
  name: string;
  description?: string | null;
  state: RewardState;
  cost: number;
  totalQuantity?: number | null;
  claimedQuantity: number;
  dateStart?: string | null;
  dateExpiration?: string | null;
};

export type UserRewardOverview = {
  userRewards: EntityListOfUserRewardDetail;
};

export type EntityListOfUserRewardDetail = {
  offset: number;
  limit: number;
  totalCount: number;
  items: UserRewardDetail[];
};

export type UserRewardDetail = {
  userRewardID: number;
  userID: number;
  rewardID: number;
  state: UserRewardState;
};

export enum UserRewardState {
  Requested = "Requested",
  Approved = "Approved",
  Denied = "Denied",
}

export type GetUserRewardListQuery = {
  offset: number;
  limit: number;
};

export type UserRewardData = {
  userRewardID: number;
  userID: number;
  rewardID: number;
  state: UserRewardState;
};

export type CreateOrUpdateUserRewardCommand = {
  userRewardID: number;
  rewardID: number;
  state: UserRewardState;
};

export type QuestDetail = {
  questID: number;
  name: string;
  description?: string | null;
  rewardXP: number;
  rewardCoins: number;
  type: QuestType;
  state: QuestState;
  dateStart: string;
  dateExpiration?: string | null;
  maxParticipants?: number | null;
  currentParticipantsCount: number;
  completedParticipantsCount: number;
};

export enum QuestType {
  Challenge = "Challenge",
  BugHunter = "BugHunter",
  Mentoring = "Mentoring",
  Engineering = "Engineering",
}

export enum QuestState {
  Requested = "Requested",
  Upcoming = "Upcoming",
  Active = "Active",
  Expired = "Expired",
  Archived = "Archived",
}

export type QuestOverview = {
  quests: EntityListOfQuestDetail;
};

export type EntityListOfQuestDetail = {
  offset: number;
  limit: number;
  totalCount: number;
  items: QuestDetail[];
};

export type QuestListRequest = {
  name?: string | null;
  offset: number;
  limit: number;
};

export type QuestData = {
  questID?: number | null;
  name: string;
  type: QuestType;
  description?: string | null;
  rewardXP: number;
  rewardCoins: number;
  state: QuestState;
  maxParticipants?: number | null;
  dateStart?: string | null;
  dateExpiration?: string | null;
};

export type CreateOrUpdateQuestCommand = {
  questID?: number | null;
  name: string;
  type: QuestType;
  description?: string | null;
  rewardXP: number;
  rewardCoins: number;
  state: QuestState;
  maxParticipants?: number | null;
  dateStart: string;
  dateExpiration?: string | null;
};

export type UserQuestOverview = {
  userQuests: EntityListOfUserQuestDetail;
};

export type EntityListOfUserQuestDetail = {
  offset: number;
  limit: number;
  totalCount: number;
  items: UserQuestDetail[];
};

export type UserQuestDetail = {
  userQuestID: number;
  userID: number;
  questID: number;
  progress: UserQuestProgress;
  dateStart?: string | null;
  dateCompleted?: string | null;
  approvedBy?: number | null;
  userName?: string | null;
  questName?: string | null;
  questDescription?: string | null;
  questType: QuestType;
  rewardCoins: number;
};

export enum UserQuestProgress {
  Requested = "Requested",
  Active = "Active",
  Pending = "Pending",
  Completed = "Completed",
  Canceled = "Canceled",
}

export type UserQuestListRequest = {
  offset: number;
  limit: number;
};

export type UserQuestData = {
  userQuestID: number;
  userID: number;
  questID: number;
  progress: UserQuestProgress;
  dateStart?: string | null;
  dateCompleted?: string | null;
  startApprovedBy?: number | null;
  completionApprovedBy?: number | null;
};

export type CreateOrUpdateUserQuestRequest = {
  userQuestID?: number | null;
  questID: number;
  progress: UserQuestProgress;
  dateStart?: string | null;
  dateCompleted?: string | null;
};

export type UserInfo = {
  token: string;
  refreshToken: string;
  email: string;
  firstName: string;
  lastName: string;
  nickname?: string | null;
  coins: number;
  xp: number;
  role: UserRole;
  label: UserLabel;
  picture?: string | null;
};

export type SignInResult = {
  userInfo: UserInfo;
};

export type ApiProblemDetailsOfAuthError = {
  errors: { [key: string | number]: ErrorDetail[] };
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
};

export enum AuthError {
  ApplicationVerification = "ApplicationVerification",
  InvalidCredentials = "InvalidCredentials",
  AccountIsDisabled = "AccountIsDisabled",
  PhoneNumberNotFound = "PhoneNumberNotFound",
  SmsSendingFailed = "SmsSendingFailed",
  InvalidToken = "InvalidToken",
  AccountWaitingForEmailConfirmation = "AccountWaitingForEmailConfirmation",
}

export type SsoSignInRequest = {
  code: string;
  redirectUri?: string | null;
  codeVerifier?: string | null;
  state?: string | null;
};

export type RefreshRequest = {
  refreshToken: string;
};

export type GetUsersFetchResponse =
  | FetchResponse<EntityListOfUserListItemDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getUsersPath = () => `/api/users`;

export const getUsers = (
  offset?: number,
  limit?: number,
  options?: FetchArgsOptions,
): Promise<GetUsersFetchResponse> => {
  const queryParams = {
    offset: offset,
    limit: limit,
  };
  return apiGet(
    `${getApiUrl()}${getUsersPath()}`,
    options,
    queryParams,
  ) as Promise<GetUsersFetchResponse>;
};

export type GetUsersUserIDFetchResponse =
  | FetchResponse<UserDetailDto, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getUsersUserIDPath = (userID: number) => `/api/users/${userID}`;

export const getUsersUserID = (
  userID: number,
  options?: FetchArgsOptions,
): Promise<GetUsersUserIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getUsersUserIDPath(userID)}`,
    options,
    {},
  ) as Promise<GetUsersUserIDFetchResponse>;
};

export type PostUsersSyncFetchResponse =
  | FetchResponse<void, 204>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postUsersSyncPath = () => `/api/users/sync`;

export const postUsersSync = (
  options?: FetchArgsOptions,
): Promise<PostUsersSyncFetchResponse> => {
  const requestData = getApiRequestData<object>(undefined, false);

  return apiPost(
    `${getApiUrl()}${postUsersSyncPath()}`,
    requestData,
    options,
  ) as Promise<PostUsersSyncFetchResponse>;
};

export type GetRewardsIdFetchResponse =
  | FetchResponse<RewardData, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getRewardsIdPath = (id: number) => `/api/rewards/${id}`;

export const getRewardsId = (
  id: number,
  options?: FetchArgsOptions,
): Promise<GetRewardsIdFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getRewardsIdPath(id)}`,
    options,
    {},
  ) as Promise<GetRewardsIdFetchResponse>;
};

export type PostRewardsOverviewFetchResponse =
  | FetchResponse<RewardOverview, 200>
  | FetchResponse<ProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postRewardsOverviewPath = () => `/api/rewards/overview`;

export const postRewardsOverview = (
  requestContract: RewardListRequest,
  options?: FetchArgsOptions,
): Promise<PostRewardsOverviewFetchResponse> => {
  const requestData = getApiRequestData<RewardListRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postRewardsOverviewPath()}`,
    requestData,
    options,
  ) as Promise<PostRewardsOverviewFetchResponse>;
};

export type PostRewardsFetchResponse =
  | FetchResponse<RewardData, 200>
  | FetchResponse<ProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postRewardsPath = () => `/api/rewards`;

export const postRewards = (
  requestContract: CreateOrUpdateRewardCommand,
  options?: FetchArgsOptions,
): Promise<PostRewardsFetchResponse> => {
  const requestData = getApiRequestData<CreateOrUpdateRewardCommand>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postRewardsPath()}`,
    requestData,
    options,
  ) as Promise<PostRewardsFetchResponse>;
};

export type PostUserRewardsOverviewFetchResponse =
  | FetchResponse<UserRewardOverview, 200>
  | FetchResponse<ProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postUserRewardsOverviewPath = () => `/api/user-rewards/overview`;

export const postUserRewardsOverview = (
  requestContract: GetUserRewardListQuery,
  options?: FetchArgsOptions,
): Promise<PostUserRewardsOverviewFetchResponse> => {
  const requestData = getApiRequestData<GetUserRewardListQuery>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postUserRewardsOverviewPath()}`,
    requestData,
    options,
  ) as Promise<PostUserRewardsOverviewFetchResponse>;
};

export type PostUserRewardsFetchResponse =
  | FetchResponse<UserRewardData, 200>
  | FetchResponse<ProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postUserRewardsPath = () => `/api/user-rewards`;

export const postUserRewards = (
  requestContract: CreateOrUpdateUserRewardCommand,
  options?: FetchArgsOptions,
): Promise<PostUserRewardsFetchResponse> => {
  const requestData = getApiRequestData<CreateOrUpdateUserRewardCommand>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postUserRewardsPath()}`,
    requestData,
    options,
  ) as Promise<PostUserRewardsFetchResponse>;
};

export type GetQuestsQuestIDFetchResponse =
  | FetchResponse<QuestDetail, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getQuestsQuestIDPath = (questID: number) =>
  `/api/quests/${questID}`;

export const getQuestsQuestID = (
  questID: number,
  options?: FetchArgsOptions,
): Promise<GetQuestsQuestIDFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getQuestsQuestIDPath(questID)}`,
    options,
    {},
  ) as Promise<GetQuestsQuestIDFetchResponse>;
};

export type PostQuestsOverviewFetchResponse =
  | FetchResponse<QuestOverview, 200>
  | FetchResponse<ProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postQuestsOverviewPath = () => `/api/quests/overview`;

export const postQuestsOverview = (
  requestContract: QuestListRequest,
  options?: FetchArgsOptions,
): Promise<PostQuestsOverviewFetchResponse> => {
  const requestData = getApiRequestData<QuestListRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postQuestsOverviewPath()}`,
    requestData,
    options,
  ) as Promise<PostQuestsOverviewFetchResponse>;
};

export type PostQuestsFetchResponse =
  | FetchResponse<QuestData, 200>
  | FetchResponse<ProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postQuestsPath = () => `/api/quests`;

export const postQuests = (
  requestContract: CreateOrUpdateQuestCommand,
  options?: FetchArgsOptions,
): Promise<PostQuestsFetchResponse> => {
  const requestData = getApiRequestData<CreateOrUpdateQuestCommand>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postQuestsPath()}`,
    requestData,
    options,
  ) as Promise<PostQuestsFetchResponse>;
};

export type PostUserQuestsOverviewFetchResponse =
  | FetchResponse<UserQuestOverview, 200>
  | FetchResponse<ProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postUserQuestsOverviewPath = () => `/api/user-quests/overview`;

export const postUserQuestsOverview = (
  requestContract: UserQuestListRequest,
  options?: FetchArgsOptions,
): Promise<PostUserQuestsOverviewFetchResponse> => {
  const requestData = getApiRequestData<UserQuestListRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postUserQuestsOverviewPath()}`,
    requestData,
    options,
  ) as Promise<PostUserQuestsOverviewFetchResponse>;
};

export type PostUserQuestsFetchResponse =
  | FetchResponse<UserQuestData, 200>
  | FetchResponse<ProblemDetails, 400>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postUserQuestsPath = () => `/api/user-quests`;

export const postUserQuests = (
  requestContract: CreateOrUpdateUserQuestRequest,
  options?: FetchArgsOptions,
): Promise<PostUserQuestsFetchResponse> => {
  const requestData = getApiRequestData<CreateOrUpdateUserQuestRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postUserQuestsPath()}`,
    requestData,
    options,
  ) as Promise<PostUserQuestsFetchResponse>;
};

export type GetAuthUserinfoFetchResponse =
  | FetchResponse<UserInfo, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const getAuthUserinfoPath = () => `/api/auth/userinfo`;

export const getAuthUserinfo = (
  options?: FetchArgsOptions,
): Promise<GetAuthUserinfoFetchResponse> => {
  return apiGet(
    `${getApiUrl()}${getAuthUserinfoPath()}`,
    options,
    {},
  ) as Promise<GetAuthUserinfoFetchResponse>;
};

export type PostAuthGoogleFetchResponse =
  | FetchResponse<SignInResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ApiProblemDetailsOfAuthError, 404>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postAuthGooglePath = () => `/api/auth/google`;

export const postAuthGoogle = (
  requestContract: SsoSignInRequest,
  options?: FetchArgsOptions,
): Promise<PostAuthGoogleFetchResponse> => {
  const requestData = getApiRequestData<SsoSignInRequest>(
    requestContract,
    false,
  );

  return apiPost(
    `${getApiUrl()}${postAuthGooglePath()}`,
    requestData,
    options,
  ) as Promise<PostAuthGoogleFetchResponse>;
};

export type PostAuthRefreshFetchResponse =
  | FetchResponse<SignInResult, 200>
  | FetchResponse<ApiProblemDetails, 401>
  | FetchResponse<ProblemDetails, 500>
  | ErrorResponse;

export const postAuthRefreshPath = () => `/api/auth/refresh`;

export const postAuthRefresh = (
  requestContract: RefreshRequest,
  options?: FetchArgsOptions,
): Promise<PostAuthRefreshFetchResponse> => {
  const requestData = getApiRequestData<RefreshRequest>(requestContract, false);

  return apiPost(
    `${getApiUrl()}${postAuthRefreshPath()}`,
    requestData,
    options,
  ) as Promise<PostAuthRefreshFetchResponse>;
};
